import './ProfileAvatar.less';

import React from 'react';

function ProfileAvatar({ avatarId, staticUrl }) {
    return (
        <div className="flex items-center justify-center betbook-profile-avatar-box">
            <img className="betbook-profile-avatar" src={`${staticUrl}/asset/avatar/${avatarId}.png`} alt="avatar" />
        </div>
    );
}

export default ProfileAvatar;
